<div *ngIf="currentTrip != undefined">
  <app-plan-trip-order-sequence
    [trip]="currentTrip"
    [isCloseable]="isDialogCloseable"
    (dialogClose)="closeDialog(event)"
  ></app-plan-trip-order-sequence>
</div>
